// Generated DB Item type: PermissionAPI
export * from './types.js';
export * from './db-def.js';
export * from './api-def.js';
//# sourceMappingURL=index.js.map